// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var Caml_array = require("bs-platform/lib/js/caml_array.js");
var Caml_int32 = require("bs-platform/lib/js/caml_int32.js");
var Caml_format = require("bs-platform/lib/js/caml_format.js");

var workoutLevels = /* array */[
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ],
  /* array */[
    1,
    1,
    1,
    1,
    1,
    1
  ]
];

var exercises = /* array */[
  /* record */[
    /* id */1,
    /* title */"Superman"
  ],
  /* record */[
    /* id */2,
    /* title */"Liegestütz"
  ],
  /* record */[
    /* id */3,
    /* title */"Türziehen"
  ],
  /* record */[
    /* id */4,
    /* title */"Dips"
  ],
  /* record */[
    /* id */5,
    /* title */"Enge Liegestütz"
  ],
  /* record */[
    /* id */6,
    /* title */"Planke"
  ],
  /* record */[
    /* id */7,
    /* title */"Sumokniebeuge auf Zehenspitzen"
  ],
  /* record */[
    /* id */8,
    /* title */"Hip Thrusts"
  ],
  /* record */[
    /* id */9,
    /* title */"Ausfallschritte seitlich"
  ],
  /* record */[
    /* id */10,
    /* title */"Seitliches Beinheben im Liegen"
  ],
  /* record */[
    /* id */11,
    /* title */"Kickbacks"
  ],
  /* record */[
    /* id */12,
    /* title */"Lunges"
  ],
  /* record */[
    /* id */13,
    /* title */"Liegestütz aus dem Stand"
  ],
  /* record */[
    /* id */14,
    /* title */"Hüftanheben im Unterarmstütz"
  ],
  /* record */[
    /* id */15,
    /* title */"Käfer"
  ],
  /* record */[
    /* id */16,
    /* title */"Superman around the world"
  ],
  /* record */[
    /* id */17,
    /* title */"Seitliches Aufdrehen"
  ],
  /* record */[
    /* id */18,
    /* title */"Burpees"
  ],
  /* record */[
    /* id */19,
    /* title */"Squats"
  ],
  /* record */[
    /* id */20,
    /* title */"Lunges Diagonal"
  ],
  /* record */[
    /* id */21,
    /* title */"Hüftstoß auf dem Rücken"
  ],
  /* record */[
    /* id */22,
    /* title */"Jumping Lunges"
  ],
  /* record */[
    /* id */23,
    /* title */"Einbeiniges Kreuzheben"
  ],
  /* record */[
    /* id */24,
    /* title */"Abduktion im Vierfüßlerstand"
  ],
  /* record */[
    /* id */25,
    /* title */"Crunches around the world"
  ],
  /* record */[
    /* id */26,
    /* title */"Einbeiniges Beinanheben auf dem Rücken"
  ],
  /* record */[
    /* id */27,
    /* title */"Cross Fit Sit Ups"
  ],
  /* record */[
    /* id */28,
    /* title */"Klappmesser mit gestreckten Beinen"
  ],
  /* record */[
    /* id */29,
    /* title */"Sit Ups mit erhöhten Beinen + Twist"
  ],
  /* record */[
    /* id */30,
    /* title */"Plank Jumping Jacks"
  ],
  /* record */[
    /* id */31,
    /* title */"Wall Sit"
  ],
  /* record */[
    /* id */32,
    /* title */"Einbeinige Kniebeuge"
  ],
  /* record */[
    /* id */33,
    /* title */"Good Mornings"
  ],
  /* record */[
    /* id */34,
    /* title */"Kniebeuge seitlich gehend"
  ],
  /* record */[
    /* id */35,
    /* title */"Seitl. Beinheben im Stehen"
  ],
  /* record */[
    /* id */36,
    /* title */"„König der Trottel“"
  ],
  /* record */[
    /* id */37,
    /* title */"Goblet Squats"
  ],
  /* record */[
    /* id */38,
    /* title */"Thomas Stretch"
  ],
  /* record */[
    /* id */39,
    /* title */"Brustkorbmobility an der Wand"
  ],
  /* record */[
    /* id */40,
    /* title */"Kniebeugeposition mit seitl. Aufdrehen"
  ],
  /* record */[
    /* id */41,
    /* title */"Kniebeuge mit Armöffnung oben an der Wand"
  ],
  /* record */[
    /* id */42,
    /* title */"Wirbelsäulenrotation im Liegen"
  ],
  /* record */[
    /* id */43,
    /* title */"Standwaage"
  ],
  /* record */[
    /* id */44,
    /* title */"Seestern"
  ],
  /* record */[
    /* id */45,
    /* title */"Dreipunkt-Beinscheren"
  ],
  /* record */[
    /* id */46,
    /* title */"Bodyrocks"
  ],
  /* record */[
    /* id */47,
    /* title */"Planking"
  ],
  /* record */[
    /* id */48,
    /* title */"Hüftheben (seitlich)"
  ]
];

var workoutMatrix = /* array */[
  /* array */[
    1,
    2,
    3,
    4,
    5,
    6
  ],
  /* array */[
    7,
    8,
    9,
    10,
    11,
    12
  ],
  /* array */[
    13,
    14,
    15,
    16,
    17,
    18
  ],
  /* array */[
    19,
    20,
    21,
    22,
    23,
    24
  ],
  /* array */[
    0,
    0,
    0,
    0,
    0,
    0
  ],
  /* array */[
    25,
    26,
    27,
    28,
    29,
    30
  ],
  /* array */[
    1,
    2,
    3,
    4,
    5,
    6
  ],
  /* array */[
    7,
    8,
    9,
    10,
    11,
    12
  ],
  /* array */[
    13,
    14,
    15,
    16,
    17,
    18
  ],
  /* array */[
    19,
    20,
    21,
    22,
    23,
    24
  ],
  /* array */[
    0,
    0,
    0,
    0,
    0,
    0
  ],
  /* array */[
    31,
    32,
    33,
    34,
    35,
    36
  ],
  /* array */[
    1,
    2,
    3,
    4,
    5,
    6
  ],
  /* array */[
    7,
    8,
    9,
    10,
    11,
    12
  ],
  /* array */[
    13,
    14,
    15,
    16,
    17,
    18
  ],
  /* array */[
    19,
    20,
    21,
    22,
    23,
    24
  ],
  /* array */[
    0,
    0,
    0,
    0,
    0,
    0
  ],
  /* array */[
    37,
    38,
    39,
    40,
    41,
    42
  ],
  /* array */[
    1,
    2,
    3,
    4,
    5,
    6
  ],
  /* array */[
    7,
    8,
    9,
    10,
    11,
    12
  ],
  /* array */[
    13,
    14,
    15,
    16,
    17,
    18
  ],
  /* array */[
    19,
    20,
    21,
    22,
    23,
    24
  ],
  /* array */[
    0,
    0,
    0,
    0,
    0,
    0
  ],
  /* array */[
    43,
    44,
    45,
    46,
    47,
    48
  ]
];

var workoutsStatus = /* array */[
  /* record */[
    /* id */1,
    /* complete : false */0,
    /* points */0
  ],
  /* record */[
    /* id */2,
    /* complete : false */0,
    /* points */0
  ],
  /* record */[
    /* id */3,
    /* complete : false */0,
    /* points */0
  ]
];

function getWorkoutTitles(week, workout) {
  var workoutIndex = Caml_int32.imul(Caml_format.caml_int_of_string(week) - 1 | 0, 6) + (Caml_format.caml_int_of_string(workout) - 1 | 0) | 0;
  return /* array */[
          Caml_array.caml_array_get(exercises, Caml_array.caml_array_get(Caml_array.caml_array_get(workoutMatrix, workoutIndex), 0) - 1 | 0)[/* title */1],
          Caml_array.caml_array_get(exercises, Caml_array.caml_array_get(Caml_array.caml_array_get(workoutMatrix, workoutIndex), 1) - 1 | 0)[/* title */1],
          Caml_array.caml_array_get(exercises, Caml_array.caml_array_get(Caml_array.caml_array_get(workoutMatrix, workoutIndex), 2) - 1 | 0)[/* title */1],
          Caml_array.caml_array_get(exercises, Caml_array.caml_array_get(Caml_array.caml_array_get(workoutMatrix, workoutIndex), 3) - 1 | 0)[/* title */1],
          Caml_array.caml_array_get(exercises, Caml_array.caml_array_get(Caml_array.caml_array_get(workoutMatrix, workoutIndex), 4) - 1 | 0)[/* title */1],
          Caml_array.caml_array_get(exercises, Caml_array.caml_array_get(Caml_array.caml_array_get(workoutMatrix, workoutIndex), 5) - 1 | 0)[/* title */1]
        ];
}

function getWorkoutIds(week, workout) {
  var workoutIndex = Caml_int32.imul(Caml_format.caml_int_of_string(week) - 1 | 0, 6) + (Caml_format.caml_int_of_string(workout) - 1 | 0) | 0;
  return /* int array */[
          Caml_array.caml_array_get(exercises, Caml_array.caml_array_get(Caml_array.caml_array_get(workoutMatrix, workoutIndex), 0) - 1 | 0)[/* id */0],
          Caml_array.caml_array_get(exercises, Caml_array.caml_array_get(Caml_array.caml_array_get(workoutMatrix, workoutIndex), 1) - 1 | 0)[/* id */0],
          Caml_array.caml_array_get(exercises, Caml_array.caml_array_get(Caml_array.caml_array_get(workoutMatrix, workoutIndex), 2) - 1 | 0)[/* id */0],
          Caml_array.caml_array_get(exercises, Caml_array.caml_array_get(Caml_array.caml_array_get(workoutMatrix, workoutIndex), 3) - 1 | 0)[/* id */0],
          Caml_array.caml_array_get(exercises, Caml_array.caml_array_get(Caml_array.caml_array_get(workoutMatrix, workoutIndex), 4) - 1 | 0)[/* id */0],
          Caml_array.caml_array_get(exercises, Caml_array.caml_array_get(Caml_array.caml_array_get(workoutMatrix, workoutIndex), 5) - 1 | 0)[/* id */0]
        ];
}

var workoutReps = /* array */[
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ],
  /* array */[
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ],
    /* array */[
      0,
      0,
      0,
      0,
      0,
      0
    ]
  ]
];

var completedArray = /* array */[
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0
];

var bonusDone = /* array */[
  /* array */[
    /* false */0,
    /* false */0,
    /* false */0,
    /* false */0,
    /* false */0,
    /* false */0
  ],
  /* array */[
    /* false */0,
    /* false */0,
    /* false */0,
    /* false */0,
    /* false */0,
    /* false */0
  ],
  /* array */[
    /* false */0,
    /* false */0,
    /* false */0,
    /* false */0,
    /* false */0,
    /* false */0
  ],
  /* array */[
    /* false */0,
    /* false */0,
    /* false */0,
    /* false */0,
    /* false */0,
    /* false */0
  ]
];

var knowledgeRead = /* array */[
  /* true */1,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0,
  /* false */0
];

var knowledgeEntries = /* array */[
  /* record */[
    /* id */1,
    /* title */"",
    /* content */"Eine Zu- oder Abnahme auf der Waage hat nicht immer mit einer tatsächlichen Veränderung des Körperfettanteils zutun. Häufig haben andere Faktoren wie z.B. der Salzgehalt oder der Zyklus Einfluss auf das Gewicht.\n    Effektiver ist es deshalb, Umfänge mit dem Maßband zu messen und so Veränderungen über Zeit festzustellen."
  ],
  /* record */[
    /* id */2,
    /* title */"Motivationsbilder",
    /* content */"Um die Motivation aufrecht zu halten, empfehlen sich Bilder mit motivierenden Sprüchen. Hänge dir diese am besten gut sichtbar in deine Wohnung, verwende sie als Hintergrundbild für dein Handy oder folge motivierenden Social Media-Accounts.\n      "
  ],
  /* record */[
    /* id */3,
    /* title */"Volumenreiche Nahrungsauswahl",
    /* content */"Versuche Lebensmittel in deinen Ernährungsplan zu integrieren, die auf eine große Menge einen möglichst geringen Kaloriengehalt haben, wie zum Beispiel grünes Gemüse. Durch das hohe Volumen wirst du schneller und länger satt und nimmst so weniger Kalorien zu dir. Ein Beispiel: Schneide eine Zucchini mit einem Sparschäler in dünne, lange Streifen. 3 Minuten in der Pfanne dünsten. Salz, Pfeffer und Kräuter dazu. Fertig sind deine kalorienarmen, aber sättigenden Bandnudeln.\n      "
  ],
  /* record */[
    /* id */4,
    /* title */"Heißhunger",
    /* content */"Da Hunger oft mit Durst verwechselt wird, empfiehlt es sich, bei Heißhunger zunächst etwas zu trinken. Ansonsten können Kaugummis, kalorienfreie (Zero)-Getränke oder das kalorienarme Rocka Geschmackspulver SMACKTASTIC (z.B. im Kaffee oder Magerquark) helfen."
  ],
  /* record */[
    /* id */5,
    /* title */"Muskelkater",
    /* content */"Ungewohnte Bewegungen können zu Muskelkater führen, weshalb du sicher während der 28 Tage das ein oder andere Mal deine Muskeln mehr spüren wirst als gewollt. Muskelkater ist aber nicht weiter schlimm und du kannst Linderung verschaffen, etwa durch Wärme (z.B. durch einen Saunabesuch oder ein Bad), leichtes Dehnen oder eine aktive Ausdauereinheit, wie zum Beispiel das optionale Cardio-Workout in deiner App.  Hier kannst du gelegentlich nach dem Training eine Portion <a href=\"https://www.rockanutrition.de/products/hypertroph-hd-bubblegum?variant=35737154689\">Rocka Hypertroph HD</a> zu dir nehmen, denn bereits 2 g L-Carnitin können helfen, den Muskelkater zu verringern oder dem vorzubeugen."
  ],
  /* record */[
    /* id */6,
    /* title */"Shake ersetzen",
    /* content */"Ersetze deinen Shake doch mal durch die Rocka Pancakes, Muffins oder die Ice Cream. Diese Alternativen bringen Abwechslung in deinen Speiseplan und überzeugen durch nahezu identische Nährwerte. Die genauen Umrechnungsmengen findest du am Anfang deines Rezeptteils mit Rocka Produkten im eBook."
  ],
  /* record */[
    /* id */7,
    /* title */"Belohnungen",
    /* content */"Belohne dich am Ende deiner Challenge - aber nicht mit Süßem, sondern z. B. mit Dingen, die du dir sonst nicht gönnen würdest (neue Sportklamotten, Supplements, einen Kurztrip für danach, Wellness-Day usw). Es ist vor allem wichtig, dass du dir langfristige Ziele setzt. Dort angekommen, kannst du dich entsprechend belohnen! Teilziele können sich dabei unterstützen, aber auch ganz unabhängig von deinem großen Ziel eingeplant werden. So zum Beispiel kann ein Teilziel sein, dass du 3 cm Bauchumfang verlierst, dein langfristiges Ziel kann das Tragen deiner Lieblingshose sein, die dir bis vor 2 Jahren gepasst hat. Deine Motivation wird so auf einem hohen Level gehalten. "
  ],
  /* record */[
    /* id */8,
    /* title */"Zeitnahe Zwischenziele",
    /* content */"Oft kann uns ein großes Ziel in der Zukunft demotivieren weiterzumachen, da der Weg bis dorthin noch zu weit entfernt ist. Deshalb ist es wichtig, sich realistische, zeitnahe Zwischenziele zu setzen, die zu kleinen Erfolgserlebnissen führen und Motivation mit sich bringen."
  ],
  /* record */[
    /* id */9,
    /* title */"Notiere dir deine Trainingszeiten im Kalender",
    /* content */"Plane deine Woche im Voraus und richte dir früh genug Zeit für den Sport ein. So kann es nicht passieren, dass du dein wöchentliches Sportpensum nicht erreichst oder den Sport vor dir herschiebst."
  ],
  /* record */[
    /* id */10,
    /* title */"Ballaststoffe",
    /* content */"<div>Ballaststoffe wirken sich positiv auf die Verdauung und die Darmflora aus und können Krankheiten wie Diabetes oder Krebs vorbeugen. Da sie lange satt machen, spielen sie bei der Gewichtsreduktion eine große Rolle. Zu finden sind sie vor allem in in Vollkornprodukten, Hülsenfrüchten, Obst und Gemüse. Täglich sollte dein Ziel sein, mindestens 30 g Ballaststoffe zu dir zu nehmen. 5 Lebensmittel, die sich hierfür während der 28-Tage-Challenge anbieten (und ihr Ballaststoffanteil auf 100 g):</div>\n    Kidneybohnen (ungekocht): 21 g\n    Linsen (ungekocht): 19 g\n    Haferflocken: 10 g\n    Avocado: 7 g\n    Rosenkohl: 4 g\n    "
  ],
  /* record */[
    /* id */11,
    /* title */"Regeneration",
    /* content */"Regeneration ist mindestens genauso wichtig wie das Training selbst. Die Regeneration startet mit einem Cool-down (wie das funktioniert, kannst du im Trainingsteil deines eBooks nachlesen), beinhaltet aber auch die dem Training angepasste Ernährung, die Pausenzeiten zwischen den sportlichen Einheiten und vor allem den Schlaf. Im Schlaf läuft der Muskelaufbau ab und Schäden werden repariert. Schlafmangel führt zudem zu einem erhöhten Appetit und einer geringeren Leistungsfähigkeit beim Sport. Auch schnell verfügbares (=Whey-) Protein, sowie wertvolle Vitamine und Minerale können bei der Einnahme nach dem Workout eine regenerative Wirkung entfalten. Ein Snack-Shake nach dem Training, Omega 3-Kapseln (z.B. <a href=\"https://www.rockanutrition.de/collections/omega3\">Omega 3+ von Rocka</a> oder Vitamin D3 (z.B. von <a href=\"https://www.rockanutrition.de/products/vitamin-d-kapseln-120-stueck\">Rocka</a> sind also eine gute Idee."
  ],
  /* record */[
    /* id */12,
    /* title */"Vegane Burger",
    /* content */"Manchmal ist es gar nicht so einfach, aus der verfügbaren Auswahl an Lebensmitteln etwas Kreatives zu zaubern. Vielleicht gefällt dir ja die folgende Idee für vegane Burger: Einfach die erlaubte Menge an Kidneybohnen als Proteinquelle mit einer Gabel zerdrücken. Dann die erlaubte Menge an Haferflocken (Kohlenhydratquelle) dazugeben und zu einem Teig kneten. Gegebenenfalls Wasser hinzufügen, um eine homogene Masse zu erhalten. Würzen, Burger-Patties formen und in der Pfanne mit Öl (Fettquelle) anbraten."
  ],
  /* record */[
    /* id */13,
    /* title */"Gemüse lecker zubereiten",
    /* content */"1. Wie wäre es mit einem Nudelsalat aus Gurke? Dafür die Gurke mit einem Sparschäler in lange Streifen schneiden und mit einem Spritzer Zitronensaft, Salz, Pfeffer und Kräutern würzen.\n    2. Du isst gerne Kartoffelbrei? Warum statt den Kartoffeln nicht mal einfach Gemüse verwenden? Hier bieten sich zum Beispiel Brokkoli und Blumenkohl an. Einfach kochen, pürieren und würzen.\n    3. Kohlrabi sind ein super Pommes-Ersatz. Dafür die Kohlrabi in Pommesform schneiden, mit Pommesgewürz (alternativ z.B. Salz, Pfeffer, Paprika, Curry) würzen und in den Ofen geben.\n    "
  ],
  /* record */[
    /* id */14,
    /* title */"Whey-Eiskaffee",
    /* content */"Ab jetzt musst du auf einen leckeren Eiskaffee nicht mehr verzichten. Ein Protein-Eiskaffee schmeckt nicht nur köstlich, sondern kann während der 28-Tage Challenge problemlos als Snack eingesetzt werden. Dafür 30 g Whey mit einem Esslöffel Instant-Kaffeepulver (alternativ mit einem abgekühlten Kaffee oder Espresso), Wasser und Smacktastic in einen Mixer geben."
  ],
  /* record */[
    /* id */15,
    /* title */"Flüssigkeitszufuhr",
    /* content */"Trinken wir zu wenig, kann das Auswirkungen auf unsere sportliche Leistungsfähigkeit haben. Deshalb ist nicht nur deine gesamte Flüssigkeitszufuhr am Tag von Bedeutung, sondern auch ein hydrierter Start in dein Workout und das kontinuierliche Trinken währenddessen. Hierfür bietet sich vor allem Wasser an, aber auch Zero-Getränke und Kaffee in Maßen. Als Faustformel kannst du dich hier an mindestens 2 Liter pro Tag orientieren. "
  ],
  /* record */[
    /* id */16,
    /* title */"Suche dir einen Trainingsbuddy",
    /* content */"Denn gemeinsam kann man sich leichter motivieren, sich herausfordern und sich bei den einzelnen Übungen anfeuern oder unterstützen. Eine Freundin hat ebenfalls mit der 28-Tage-Challenge gestartet? Super! Mal sehen, wer in 30 Sekunden mehr Burpees schafft. In der Facebook-Army hast du die Möglichkeit, nach Gleichgesinnten - vielleicht aus derselben Umgebung - zu fragen."
  ],
  /* record */[
    /* id */17,
    /* title */"Miss dich nicht mit anderen",
    /* content */"… aber mit deinem gestrigen Ich. Es wird immer jemanden geben, der erfolgreicher ist als du. Jeder Mensch hat zudem unterschiedliche Voraussetzungen. Konzentriere dich deshalb nur auf dich selbst und versuche stetig über dich hinauszuwachsen."
  ],
  /* record */[
    /* id */18,
    /* title */"“Muscle-Mind Connection”",
    /* content */"Versuche den Muskel, den du beim Training ansteuerst, auch wirklich intensiv zu spüren, indem du dich auf ihn konzentrierst. Dieses Konzept hat Einfluss auf deinen Trainingserfolg, eine Verringerung des Verletzungsrisikos und vor allem verbessert es die Ausführung der Übung."
  ],
  /* record */[
    /* id */19,
    /* title */"Positiv denken",
    /* content */"Wir alle haben Zweifel. Doch wie wäre es, wenn du die ganzen negativen Stimmen in deinem Kopf durch positive ersetzen würdest. Sobald die innere Stimme sich mit einem Satz wie „Ich halte doch eh nichts durch“ meldet, rufe dir zugleich deine bisherigen Erfolge ins Gedächtnis und sage dir, dass du diszipliniert bist. Und sogar wenn das noch nicht der Fall sein sollte. Mit dieser Denkweise wird es schon bald Realität werden."
  ],
  /* record */[
    /* id */20,
    /* title */"Sportpause bei Krankheit",
    /* content */"Sport stärkt das Immunsystem. Solltest du nun doch einmal krank sein, lege unbedingt eine Sportpause ein, da sonst das Immunsystem noch mehr geschwächt wird und Krankheitserreger sich weiter ausbreiten können. "
  ],
  /* record */[
    /* id */21,
    /* title */"Verletzungen vorbeugen",
    /* content */"Sportverletzungen können einfach vorgebeugt werden. Am wichtigsten dafür ist es, sich vor dem Training gut aufzuwärmen. Dazu gehört sowohl das physische als auch das psychische Aufwärmen. Weißt du nicht genau, wie du das machst, schaue am besten nochmal in die Hinweise zum Training in deinem eBook. Unter “Warm-Up” findest du Anregungen dazu."
  ],
  /* record */[
    /* id */22,
    /* title */"EAA",
    /* content */"EAA steht für Essential Amino Acids. Bei den EAA handelt es sich um alle 8 essentiellen Aminosäuren: Leucin, Isoleucin, Valin, Lysin, Phenylalanin, Threonin, Methionin und das Tryptophan. Diese sind für den Muskelaufbau wichtig, in deinem Fall aber vor allem, um während der kalorienreduzierten Diät bereits existierende Muskulatur nicht zu verlieren. Außerdem verbessern sie die Regeneration und können so unter anderem Muskelkater effektiv vorbeugen. Bei der Verwendung eines EAA-Produkts sollte auf eine gute Löslichkeit und eine optimale Aminosäurenzusammensetzung geachtet werden. Beides liefern dir die Produkte von Rocka Nutrition. Zusätzlich sind sie ausgesprochen lecker im Geschmack (falls du eine schmackhafte Alternative zu Wasser haben willst), sogar vegan und frei von künstlichen Farbstoffen und Aspartam. Da sie nicht komplett kalorienfrei sind, solltest du täglich nicht mehr als 1-2 Portionen zu dir nehmen und diese am besten um dein Training herum. Für weitere Informationen zum Thema EAA kannst du dir gerne folgendes Video anschauen: <a href=\"https://www.youtube.com/watch?v=2aq1EEG-7ps\">Youtube</a>."
  ],
  /* record */[
    /* id */23,
    /* title */"Bewegung im Alltag",
    /* content */"Der wohl in Zeitschriften am häufigsten genannte Tipp, der so hilfreich ist, dass man ihn etliche Male wiederholen kann: Versuche Bewegung in deinen Alltag zu bringen, um so deinen Kalorienverbrauch zu steigern. Treppe statt Aufzug, häufiger zu Fuß gehen, eine Haltestelle früher aussteigen und laufen, mit Freunden spazieren gehen, statt in einem Café zu treffen. Kontrolliere die nächste Zeit doch mal mit einer Schrittzähler-App, wie viele Schritte du täglich zurücklegst. Versuche heute einmal auf 10.000 Schritte zu kommen. Und wenn du das geschafft hast, kannst du es direkt für die nächsten Tage beibehalten."
  ],
  /* record */[
    /* id */24,
    /* title */"Kalorienarme Saucen und Aufstriche",
    /* content */"Ersetze kalorienreiche Saucen und Aufstriche durch kalorienarme Alternativen wie die ROCKA SAUCE ZERO, die SMACKTASTIC CREAMS oder die SMACKTASTIC JAM. Du solltest nichtsdestotrotz eine bestimmte Menge nicht überschreiten (Sauce Zero: max. 2 EL pro Mahlzeit, Cream: max. 3 Portionen à 15 g pro Woche, Jam: max. 3 TL pro Tag)."
  ],
  /* record */[
    /* id */25,
    /* title */"Sei nicht zu streng zu dir selbst!",
    /* content */"Fast jeder von uns geht mit sich selbst viel strenger um als mit Freunden. Überlege dir deshalb immer, wenn du dich mal wieder verurteilst, ob du dasselbe, das du zu dir sagst, auch zu einem guten Freund sagen würdest. Und denke daran: Menschen können nicht konstant 100% geben."
  ],
  /* record */[
    /* id */26,
    /* title */"Fitness Lifestyle",
    /* content */"Fast jeder von uns geht mit sich selbst viel strenger um als mit Freunden. Überlege dir deshalb immer, wenn du dich mal wieder verurteilst, ob du dasselbe, das du zu dir sagst, auch zu einem guten Freund sagen würdest. Und denke daran: Menschen können nicht konstant 100% geben."
  ],
  /* record */[
    /* id */27,
    /* title */"Fitnessgerechte Ernährung im Restaurant",
    /* content */"Solltest du häufiger auswärts essen, empfiehlt es sich, auch hier auf fitnessgerechte Nahrung zurückzugreifen. Bestelle zum Beispiel mageres Fleisch oder Fisch mit Gemüsebeilage oder Salate und verzichte auf fettige Soßen."
  ],
  /* record */[
    /* id */28,
    /* title */"Wissen: Muskelaufbau vs. Fettverbrennung",
    /* content */"<div>Das Prinzip des Muskelaufbaus und der Fettverbrennung ist ganz einfach. Willst du zunehmen/Muskeln aufbauen, musst du in der Regel mehr Kalorien zu dir nehmen, als du eigentlich benötigst (Kalorienüberschuss).</div><div> Wenn du unter deinem Kalorienbedarf isst, also ein Kaloriendefizit fährst, verlierst du normalerweise Fett.</div>"
  ]
];

var exerciseImagesCount = /* array */[
  /* int array */[
    2,
    3,
    3
  ],
  /* int array */[
    2,
    2,
    2
  ],
  /* int array */[
    2,
    2,
    2
  ],
  /* int array */[
    2,
    2,
    2
  ],
  /* int array */[
    2,
    3,
    6
  ],
  /* int array */[
    2,
    2,
    4
  ],
  /* int array */[
    3,
    3,
    3
  ],
  /* int array */[
    2,
    2,
    3
  ],
  /* int array */[
    2,
    2,
    3
  ],
  /* int array */[
    2,
    2,
    3
  ],
  /* int array */[
    2,
    2,
    2
  ],
  /* int array */[
    2,
    3,
    3
  ],
  /* int array */[
    3,
    3,
    3
  ],
  /* int array */[
    2,
    2,
    3
  ],
  /* int array */[
    2,
    3,
    3
  ],
  /* int array */[
    3,
    3,
    3
  ],
  /* int array */[
    3,
    3,
    2
  ],
  /* int array */[
    3,
    3,
    4
  ],
  /* int array */[
    2,
    2,
    2
  ],
  /* int array */[
    2,
    2,
    3
  ],
  /* int array */[
    2,
    2,
    3
  ],
  /* int array */[
    3,
    3,
    6
  ],
  /* int array */[
    2,
    3,
    3
  ],
  /* int array */[
    2,
    2,
    2
  ],
  /* int array */[
    2,
    0,
    0
  ],
  /* int array */[
    2,
    0,
    0
  ],
  /* int array */[
    2,
    0,
    0
  ],
  /* int array */[
    2,
    0,
    0
  ],
  /* int array */[
    2,
    0,
    0
  ],
  /* int array */[
    2,
    0,
    0
  ],
  /* int array */[
    1,
    0,
    0
  ],
  /* int array */[
    2,
    0,
    0
  ],
  /* int array */[
    2,
    0,
    0
  ],
  /* int array */[
    3,
    0,
    0
  ],
  /* int array */[
    3,
    0,
    0
  ],
  /* int array */[
    1,
    0,
    0
  ],
  /* int array */[
    2,
    0,
    0
  ],
  /* int array */[
    1,
    0,
    0
  ],
  /* int array */[
    2,
    0,
    0
  ],
  /* int array */[
    2,
    0,
    0
  ],
  /* int array */[
    2,
    0,
    0
  ],
  /* int array */[
    2,
    0,
    0
  ],
  /* int array */[
    2,
    0,
    0
  ],
  /* int array */[
    2,
    0,
    0
  ],
  /* int array */[
    3,
    0,
    0
  ],
  /* int array */[
    2,
    0,
    0
  ],
  /* int array */[
    1,
    0,
    0
  ],
  /* int array */[
    2,
    0,
    0
  ]
];

var exerciseDescriptions = /* array */[
  /* record */[
    /* id */1,
    /* description : array */[
      "Lege dich bäuchlings auf den Boden, strecke deine Arme nach vorne und deine Beine nach hinten aus. Winkle beide Arme an, sodass sich dein Ober- und Unterarm in einem 90-Grad-Winkel zueinander befinden. Hebe die Arme und Beine nach oben an. Halte die Spannung am höchsten Punkt. Senke Arme und Beine zum Boden.",
      "Lege dich bäuchlings auf den Boden, strecke deine Arme nach vorne und deine Beine nach hinten aus. Hebe gleichzeitig beide Arme und beide Beine im ausgestreckten Zustand nach oben an. Halte die Spannung am höchsten Punkt. Senke die Arme und Beine zum Boden.",
      "Lege dich bäuchlings auf den Boden, strecke deine Arme nach vorne und deine Beine nach hinten aus. Hebe gleichzeitig beide Arme und beide Beine im ausgestreckten Zustand nach oben an. Grätsche beim Hochgehen die Beine. Halte die Spannung am höchsten Punkt. Senke die Arme und Beine zum Boden und schließe die Beine."
    ]
  ],
  /* record */[
    /* id */2,
    /* description : array */[
      "Stütze dich mit gestreckten Armen und dem Gesicht zum Boden schulterbreit oder etwas breiter auf deine Hände, die Beine liegen dabei nebeneinander oder sind leicht gegrätscht. Beuge die Arme, sodass sich dein Oberkörper dem Boden nähert. Setze deinen Körper dabei unter Spannung und lasse kein Hohlkreuz entstehen. Drücke dich wieder vom Boden hoch, bis die Arme fast vollkommen gestreckt sind. Führe die Übung auf den Knien aus.",
      "Stütze dich mit gestreckten Armen und dem Gesicht zum Boden schulterbreit oder etwas breiter auf deine Hände, die Beine liegen dabei nebeneinander oder sind leicht gegrätscht. Beuge die Arme, sodass sich dein Oberkörper dem Boden nähert. Setze deinen Körper dabei unter Spannung und lasse kein Hohlkreuz entstehen. Drücke dich wieder vom Boden hoch, bis die Arme fast vollkommen gestreckt sind. Führe die Übung auf den Fußspitzen aus.",
      "Stütze dich mit gestreckten Armen und dem Gesicht zum Boden schulterbreit oder etwas breiter auf deine Hände, die Beine liegen dabei nebeneinander oder sind leicht gegrätscht. Beuge die Arme, sodass sich dein Oberkörper dem Boden nähert. Setze deinen Körper dabei unter Spannung und lasse kein Hohlkreuz entstehen. Drücke dich wieder vom Boden hoch, bis die Arme fast vollkommen gestreckt sind. Deine Beine sind erhöht, zum Beispiel indem du sie auf einen Stuhl legst."
    ]
  ],
  /* record */[
    /* id */3,
    /* description : array */[
      "Umgreife die Türgriffe einer geöffneten Tür (benutze je nach Bedarf ein Handtuch, das du um den Türgriff legst) und platziere deine Füße links und rechts neben der Tür, deine Füße befinden sich unter den Türgriffen. Halte deine Beine nahezu gestreckt und lehne dich minimal zurück, dein Rücken bleibt gerade. Ziehe dich zur Tür und beuge deine Arme. Deine Ellenbogen gehen dicht am Körper entlang. Die Endposition ist erreicht, sobald die Brust die Tür berührt. Lasse dich nun kontrolliert in die Ausgangsposition zurück.",
      "Umgreife die Türgriffe einer geöffneten Tür (benutze je nach Bedarf ein Handtuch, das du um den Türgriff legst) und platziere deine Füße links und rechts neben der Tür, deine Füße befinden sich unter den Türgriffen. Beuge deine Beine nun leicht und lehne dich etwas nach hinten, dein Rücken bleibt gerade. Ziehe dich zur Tür und beuge deine Arme. Deine Ellenbogen gehen dicht am Körper entlang. Die Endposition ist erreicht, sobald die Brust die Tür berührt. Lasse dich nun kontrolliert in die Ausgangsposition zurück.",
      "Lege dich unter einen Tisch und strecke deine Arme senkrecht zur Tischkante nach oben. Umgreife nun die Kante des Tisches, deine Fersen bleiben auf dem Boden. Ziehe dich mit der Brust zur Tischkante, der Rücken bleibt gerade. Lasse dich kontrolliert in die Ausgangsposition zurück, indem du die Arme streckst."
    ]
  ],
  /* record */[
    /* id */4,
    /* description : array */[
      "Stütze dich in Schulterbreite mit deinen Händen auf den Rand einer Erhöhung. Stelle deine Füße auf den Boden. Ober- und Unterschenkel befinden sich in etwa im 90-Grad-Winkel zueinander. Beuge deine Arme so weit wie möglich. Drücke dich dann wieder nach oben.",
      "Stütze dich in Schulterbreite mit deinen Händen auf den Rand einer Erhöhung. Deine Beine sind ausgestreckt. Beuge deine Arme so weit wie möglich und drücke dich dann wieder nach oben.",
      "Stütze dich in Schulterbreite mit deinen Händen auf den Rand einer Erhöhung. Lege deine Fersen auf eine andere Erhöhung, zum Beispiel einen anderen Stuhl, sodass sich dein Körper in der Luft befindet. Deine Beine sind ausgestreckt. Beuge deine Arme so weit wie möglich und drücke dich dann wieder nach oben."
    ]
  ],
  /* record */[
    /* id */5,
    /* description : array */[
      "Gehe auf die Knie. Stütze dich mit gestreckten Armen und dem Gesicht zum Boden auf deine Hände. Diese liegen direkt nebeneinander, die Fingerspitzen sind geradeaus gerichtet. Beuge die Arme, sodass sich dein Oberkörper dem Boden nähert. Die Ellenbogen bleiben dabei dicht am Körper. Drücke dich vom Boden hoch, bis die Arme fast vollkommen gestreckt sind. Beuge die Arme erneut.",
      "Gehe auf die Knie. Stütze dich mit gestreckten Armen und dem Gesicht zum Boden auf deine Hände. Diese liegen direkt nebeneinander, die Fingerspitzen sind geradeaus gerichtet. Beuge die Arme, sodass sich dein Oberkörper dem Boden nähert. Die Ellenbogen bleiben dabei dicht am Körper. Nachdem du deine Arme gebeugt hast, legst du deinen Oberkörper auf dem Boden ab und klatscht die Hände einmal hinter deinem Rücken zusammen. Positioniere deine Hände erneut wie in der Ausgangsposition beschrieben und drücke dich vom Boden hoch.",
      "Gehe auf die Knie. Stütze dich mit gestreckten Armen und dem Gesicht zum Boden auf deine Hände. Diese liegen direkt nebeneinander, die Fingerspitzen sind geradeaus gerichtet. Beuge die Arme, sodass sich dein Oberkörper dem Boden nähert. Die Ellenbogen bleiben dabei dicht am Körper. Drücke dich zurück nach oben. Begib dich auf die Fußspitzen in die Liegestützposition. Lege nun zunächst deinen rechten, dann den linken Unterarm auf dem Boden ab, sodass sich deine Ellenbogen unter deinen Schultern befinden. Drücke dich mit dem einen, dann mit dem anderen Arm zurück in die Liegestützposition und führe erneut eine enge Liegestütze auf den Knien aus."
    ]
  ],
  /* record */[
    /* id */6,
    /* description : array */[
      "Du liegst bäuchlings auf dem Boden und stützt dich auf deine Unterarme, die sich parallel zueinander unter deinen Schultern befinden. Deine Beine sind in Hüftbreite gerade nach hinten ausgestreckt. Hebe deine Hüfte, sodass sich dein Körper in einer Linie befindet, der Rücken ist gerade. Halte die Position so lange wie möglich.",
      "Du liegst bäuchlings auf dem Boden und stützt dich auf deine Unterarme, die sich parallel zueinander unter deinen Schultern befinden. Deine Beine sind in Hüftbreite gerade nach hinten ausgestreckt. Hebe deine Hüfte, sodass sich dein Körper in einer Linie befindet, der Rücken ist gerade. Hebe deine Beine im Wechsel nach oben an.",
      "Du liegst bäuchlings auf dem Boden und stützt dich auf deine Unterarme, die sich parallel zueinander unter deinen Schultern befinden. Deine Beine sind in Hüftbreite gerade nach hinten ausgestreckt. Hebe deine Hüfte, sodass sich dein Körper in einer Linie befindet, der Rücken ist gerade. Steige mit den Armen abwechselnd auf."
    ]
  ],
  /* record */[
    /* id */7,
    /* description : array */[
      "Stelle deine Füße etwas breiter als hüftbreit auf. Versetze deinen Oberkörper unter Spannung, beuge deine Beine im Kniegelenk und schiebe dabei dein Gesäß nach hinten. Gehe so weit nach unten, wie es dir möglich ist. Richte dich wieder auf und gehe dabei auf die Zehenspitzen. Halte die Position im gestreckten Zustand für 3 Sekunden. Wiederhole die Bewegung und begib dich bei der Abbewegung zurück auf deine gesamte Fußsohle.",
      "Stelle deine Füße etwas breiter als hüftbreit auf. Versetze deinen Oberkörper unter Spannung, beuge deine Beine im Kniegelenk und schiebe dabei dein Gesäß nach hinten. Gehe so weit nach unten, wie es dir möglich ist. Mache dazwischen eine normale Sumokniebeuge, bei der du NICHT auf die Zehenspitzen gehst und die du auch NICHT 3 Sekunden lang hältst.",
      "Stelle deine Füße etwas breiter als hüftbreit auf. Versetze deinen Oberkörper unter Spannung, beuge deine Beine im Kniegelenk und schiebe dabei dein Gesäß nach hinten. Gehe so weit nach unten, wie es dir möglich ist. Richte dich wieder auf und gehe dabei auf die Zehenspitzen. Halte die Position im gestreckten Zustand für 3 Sekunden. Wiederhole die Bewegung und begib dich bei der Abbewegung zurück auf deine gesamte Fußsohle. Führe diese Bewegung 2 Mal aus. Anschließend machst du eine normale Sumokniebeuge,  bei der du NICHT auf die Zehenspitzen gehst und die du auch NICHT 3 Sekunden lang hältst."
    ]
  ],
  /* record */[
    /* id */8,
    /* description : array */[
      "Du liegst auf dem Rücken, deine Beine sind aufgestellt und deine Arme liegen entlang deines Körpers mit den Handflächen zum Boden. Drücke dein Becken so hoch wie möglich. Halte dein Becken für etwa 2 Sekunden oben unter Spannung. Lasse dein Becken wieder langsam heruntersinken, berühre jedoch nicht mehr den Boden und drücke es kurz vor dem Ablegen wieder hoch. Führe die Übung auf beiden Beinen aus.",
      "Du liegst auf dem Rücken, deine Beine sind aufgestellt und deine Arme liegen entlang deines Körpers mit den Handflächen zum Boden. Drücke dein Becken so hoch wie möglich. Halte dein Becken für etwa 2 Sekunden oben unter Spannung. Lasse dein Becken wieder langsam heruntersinken, berühre jedoch nicht mehr den Boden und drücke es kurz vor dem Ablegen wieder hoch. Hebe ein Bein vom Boden an. Wechsle bei jeder Wiederholung das angehobene Bein.",
      "Du liegst auf dem Rücken, deine Beine sind aufgestellt und deine Arme liegen entlang deines Körpers mit den Handflächen zum Boden. Drücke dein Becken so hoch wie möglich. Halte dein Becken für etwa 2 Sekunden oben unter Spannung. Lasse dein Becken wieder langsam heruntersinken, berühre jedoch nicht mehr den Boden und drücke es kurz vor dem Ablegen wieder hoch. Führe die Übung erst auf einem Bein, dann auf beiden Beinen und dann wieder auf einem Bein durch. Hebe das rechte und das linke Bein im Wechsel an."
    ]
  ],
  /* record */[
    /* id */9,
    /* description : array */[
      "Stelle dich schulterbreit hin und positioniere die Hände vor deinem Körper. Mache einen Schritt nach links und beuge schließlich das linke Knie. Schiebe dabei das Gesäß nach hinten und beuge den Oberkörper leicht nach vorne. Der Oberschenkel des gebeugten Beines sollte nun parallel zum Boden sein. Richte dich wieder auf und wiederhole die Bewegung mit dem anderen Bein.",
      "Stelle dich schulterbreit hin und positioniere die Hände vor deinem Körper. Mache einen Schritt nach links und beuge schließlich das linke Knie. Während du dein Gesäß nach hinten schiebst, streckst du deine Arme zur Seite aus, die Fingerspitzen zeigen nach oben und die Handflächen nach außen vom Körper weg. Dabei ziehst du mit den Fingerspitzen nach oben. Richte dich wieder auf und bringe deine Arme nach unten. Wiederhole die Bewegung mit dem anderen Bein.",
      "Stelle dich schulterbreit hin und positioniere die Hände vor deinem Körper. Strecke deine Arme über dem Kopf aus, die Handflächen berühren sich. Mache mit dem rechten Bein einen Schritt nach vorne und beuge dein rechtes Knie im 90-Grad-Winkel.  Strecke die Arme nun auf einer Linie zur Seite aus und kippe deinen Oberkörper nach rechts, sodass die rechte Hand den Boden berührt, die linke Hand zur Decke zeigt. Führe den Oberkörper zurück zur Mitte und bringe deine Arme zurück nach oben. Stoße dich mit dem rechten Bein am Boden ab und komme zurück in die Startposition, wiederhole die Bewegung mit dem anderen Bein."
    ]
  ],
  /* record */[
    /* id */10,
    /* description : array */[
      "Lege dich auf deine rechte Seite, deine Beine sind gestreckt und das linke Bein liegt auf dem rechten. Stemme deine linke Hand in die Hüfte, die rechte Hand stützt du unter den Kopf. Hebe dein linkes Bein nach oben an, bis es sich in etwa in einem 45-Grad-Winkel zu deinem anderen Bein befindet. Halte die Position kurz und bringe das linke Bein dann wieder nach unten, lege es aber nicht vollständig ab. Wiederhole die Ausführung. Nachdem du das Bein 10 Mal angehoben hast, wechselst du die Seite.",
      "Lege dich auf deine rechte Seite, deine Beine sind gestreckt und das linke Bein liegt auf dem rechten. Stemme deine linke Hand in die Hüfte und begib dich in den Seitstütz. Hierfür legst du deinen Unterarm auf dem Boden ab. Deine Hand zeigt in dieselbe Richtung wie dein Gesicht. Bringe dein Becken nach oben, dein Körper bildet eine gerade Linie. Hebe dein linkes Bein nach oben an, bis es sich in etwa in einem 45-Grad-Winkel zu deinem anderen Bein befindet. Halte die Position kurz und bringe das linke Bein dann wieder nach unten, lege es aber nicht vollständig ab. Wiederhole die Ausführung. Nachdem du das Bein 10 Mal angehoben hast, wechselst du die Seite.",
      "Lege dich auf deine rechte Seite, deine Beine sind gestreckt und das linke Bein liegt auf dem rechten. Stemme deine linke Hand in die Hüfte, du stützt dich dabei auf deinen rechten Unterarm. Hebe dein linkes Bein nach oben an, bis es sich in etwa in einem 45-Grad-Winkel zu deinem anderen Bein befindet. Halte die Position kurz und bringe das linke Bein dann wieder nach unten. Im Anschluss bringst du dein Becken nach oben und wieder nach unten. Wiederhole die Ausführung. Nachdem du das Bein und die Hüfte jeweils 10 Mal nach oben angehoben hast, wechselst du die Seite."
    ]
  ],
  /* record */[
    /* id */11,
    /* description : array */[
      "Gehe in den Vierfüßlerstand und stütze dich dabei auf deine Hände. Strecke das rechte Bein nach hinten aus, sodass es auf einer Linie mit dem Rücken ist. Ziehe die Zehenspitzen Richtung Schienbein und beuge das Knie, sodass Oberschenkel und Unterschenkel in einem rechten Winkel zueinander stehen. Kicke dein angewinkeltes Bein nun nach oben. Ziehe dein Knie kontrolliert zur Brust. Wiederhole die Bewegung mit dem linken Bein.",
      "Gehe in den Vierfüßlerstand und stütze dich dabei auf deine Hände. Strecke das rechte Bein nach hinten aus, sodass es auf einer Linie mit dem Rücken ist. Ziehe die Zehenspitzen Richtung Schienbein und beuge das Knie, sodass Oberschenkel und Unterschenkel in einem rechten Winkel zueinander stehen. Kicke dein angewinkeltes Bein nun nach oben. Bring es nun den halben Weg zurück nach unten und ziehe es erneut nach oben. Bringe dann das Knie kontrolliert zur Brust. Wiederhole die Bewegung mit dem linken Bein.",
      "Gehe in den Vierfüßlerstand und stütze dich dabei auf deine Hände. Strecke das rechte Bein nach hinten aus, sodass es auf einer Linie mit dem Rücken ist. Ziehe die Zehenspitzen Richtung Schienbein und beuge das Knie, sodass Oberschenkel und Unterschenkel in einem rechten Winkel zueinander stehen. Kicke dein angewinkeltes Bein nun nach oben. Ziehe dein Knie kontrolliert zur Brust. Strecke dein Bein nun gerade nach hinten aus und kicke es nach oben. Ziehe dann das Bein kontrolliert zurück und wiederhole die zwei Kicks mit dem anderen Bein."
    ]
  ],
  /* record */[
    /* id */12,
    /* description : array */[
      "Du stehst hüftbreit. Mache einen großen Schritt nach hinten und beuge das vordere Bein, sodass die Wade und der Oberschenkel dieses Beines einen 90-Grad-Winkel ergeben. Halte den Oberkörper dabei aufrecht. Drücke dich aus dem Gesäß zurück in den Stand und führe die gleiche Bewegung nun mit deinem anderen Bein durch.",
      "Du stehst hüftbreit. Mache einen großen Schritt nach hinten und beuge das vordere Bein, sodass die Wade und der Oberschenkel dieses Beines einen 90-Grad-Winkel ergeben. Halte den Oberkörper dabei aufrecht. Drücke dich mit dem vorderen Bein wieder nach oben. Ziehe das Knie des hinteren Beines Richtung Brust und stelle es schließlich wieder auf den Boden neben das andere Bein. Wiederhole die komplette Bewegung, indem du nun mit dem anderen Bein nach hinten gehst.",
      "Du stehst hüftbreit. Mache einen großen Schritt nach hinten und beuge das vordere Bein, sodass die Wade und der Oberschenkel dieses Beines einen 90-Grad-Winkel ergeben. Halte den Oberkörper dabei aufrecht. Drücke dich mit dem vorderen Bein wieder nach oben. Ziehe das Knie des hinteren Beines Richtung Brust und stelle es schließlich wieder auf den Boden neben das andere Bein. Während du das Knie anziehst, springst du mit dem anderen Bein nach oben."
    ]
  ],
  /* record */[
    /* id */13,
    /* description : array */[
      "Stelle dich aufrecht hin. Positioniere die Hände schulterbreit auf dem Boden (gehe dabei wenn nötig leicht in die Knie). Nimm eine Liegestützposition ein. Du gehst mit deinen Beinen also nach hinten und senkst dein Gesäß Richtung Boden. Begib dich auf die Knie. Beuge die Arme, sodass sich dein Oberkörper dem Boden nähert. Setze deinen Körper dabei unter Spannung und lasse kein Hohlkreuz entstehen. Drücke dich wieder vom Boden hoch, bis die Arme fast vollkommen gestreckt sind. Stelle dich erneut aufrecht hin.",
      "Stelle dich aufrecht hin. Positioniere die Hände schulterbreit auf dem Boden (gehe dabei wenn nötig leicht in die Knie). Laufe mit den Händen nach vorne in die Liegestützposition.\n        Begib dich auf die Knie. Beuge die Arme, sodass sich dein Oberkörper dem Boden nähert. Setze deinen Körper dabei unter Spannung und lasse kein Hohlkreuz entstehen. Drücke dich wieder vom Boden hoch, bis die Arme fast vollkommen gestreckt sind. Erhebe deine Knie, sodass du wieder in einer Liegestützposition bist und laufe nun mit den Händen zurück in den Stand.",
      "Stelle dich aufrecht hin. Positioniere die Hände schulterbreit auf dem Boden (gehe dabei wenn nötig leicht in die Knie). Laufe mit den Händen nach vorne in die Liegestützposition.\n        Beuge die Arme, sodass sich dein Oberkörper dem Boden nähert. Setze deinen Körper dabei unter Spannung und lasse kein Hohlkreuz entstehen. Drücke dich wieder vom Boden hoch, bis die Arme fast vollkommen gestreckt sind. Laufe nun mit den Händen zurück in den Stand."
    ]
  ],
  /* record */[
    /* id */14,
    /* description : array */[
      "Stütze dich auf deine Unterarme, die sich parallel zueinander unter deinen Schultern befinden. Du befindest dich auf den Zehenspitzen und deine Beine sind gerade in Hüftbreite nach hinten ausgestreckt. Hebe deine Hüfte, sodass sich dein Körper in einer Linie befindet, der Rücken ist gerade. Hebe die Hüfte Richtung Decke, bis dein Körper ein umgedrehtes \"V\" ergibt. Komme zurück in die Ausgangsposition.",
      "Stütze dich auf deine Unterarme, die sich parallel zueinander unter deinen Schultern befinden. Du befindest dich auf den Zehenspitzen und deine Beine sind gerade in Hüftbreite nach hinten ausgestreckt. Hebe deine Hüfte, sodass sich dein Körper in einer Linie befindet, der Rücken ist gerade. Hebe ein Bein vom Boden ab und hebe die Hüfte Richtung Decke, bis dein Körper ein umgedrehtes \"V\" ergibt. Komme zurück in die Ausgangsposition. Wechsle das angehobene Bein bei jeder Wiederholung.",
      "Stütze dich auf deine Unterarme, die sich parallel zueinander unter deinen Schultern befinden. Du befindest dich auf den Zehenspitzen und deine Beine sind gerade in Hüftbreite nach hinten ausgestreckt. Hebe deine Hüfte, sodass sich dein Körper in einer Linie befindet, der Rücken ist gerade. Hebe die Hüfte zunächst in Richtung Decke, bis dein Körper ein umgedrehtes \"V\" ergibt. Führe nun einen Sprung mit seitwärts gespreizten Beinen aus und springe dann wieder mit den Beinen zur Mitte. Komme jetzt erst wieder zurück in die Ausgangsposition."
    ]
  ],
  /* record */[
    /* id */15,
    /* description : array */[
      "Lege dich gerade auf den Rücken, die Beine sind ausgestreckt. Platziere die Hände als Nackenstütze hinter dem Kopf. Hebe die Füße und winkle die Knie an, sodass sich dein Ober- und Unterschenkel in einem 90-Grad-Winkel zueinander befinden. Strecke ein Bein aus und ziehe das Knie des anderen Beines Richtung Brust. Probiere gleichzeitig mit dem gegenüberliegenden Ellenbogen dein Knie zu berühren, indem du eine Rotationsbewegung vom Ellenbogen hin zum Knie ausführst. Ziehe jetzt das ausgestreckte Bein Richtung Brust, strecke das andere Bein aus und führe eine Rotationsbewegung durch, sodass diesmal der Ellenbogen der anderen Seite das angezogene Knie berührt.",
      "Lege dich gerade auf den Rücken, die Beine sind ausgestreckt. Hebe die Füße und winkle die Knie an, sodass sich dein Ober- und Unterschenkel in einem 90-Grad-Winkel zueinander befinden. Strecke ein Bein aus und ziehe das Knie des anderen Beines Richtung Brust. Probiere gleichzeitig mit dem gegenüberliegenden Ellenbogen dein Knie zu berühren, indem du eine Rotationsbewegung vom Ellenbogen hin zum Knie ausführst. Wiederhole die Bewegung zur anderen Seite. Strecke danach die Hände vor dem Körper aus. Ziehe die Knie gleichzeitig so weit wie möglich Richtung Brust und umgreife sie mit deinen Armen. Strecke die Beine wieder aus, öffne die Arme und mache erneut eine Wiederholung.",
      "Lege dich gerade auf den Rücken, die Beine sind ausgestreckt. Platziere die Hände als Nackenstütze hinter dem Kopf. Hebe die Füße und winkle die Knie an, sodass sich dein Ober- und Unterschenkel in einem 90-Grad-Winkel zueinander befinden. Strecke ein Bein aus und ziehe das Knie des anderen Beines Richtung Brust. Probiere gleichzeitig mit dem gegenüberliegenden Ellenbogen dein Knie zu berühren, indem du eine Rotationsbewegung vom Ellenbogen hin zum Knie ausführst. Wiederhole die Bewegung zur anderen Seite. Strecke danach die Hände vor dem Körper aus. Ziehe die Knie gleichzeitig so weit wie möglich Richtung Brust und umgreife sie mit deinen Armen. Strecke die Beine halb aus und ziehe sie erneut an. Strecke nun die Beine ganz aus und öffne die Arme."
    ]
  ],
  /* record */[
    /* id */16,
    /* description : array */[
      "Lege dich bäuchlings auf den Boden, strecke deine Arme nach vorne und deine Beine nach hinten aus. Erhebe deinen Oberkörper vom Boden. Bringe deine gestreckten Arme neben deinen Körper und wieder zurück nach vorne. Wiederhole die Bewegung.",
      "Lege dich bäuchlings auf den Boden, strecke deine Arme nach vorne und deine Beine nach hinten aus. Erhebe deinen Oberkörper und deine Beine. Bringe deine gestreckten Arme neben deinen Körper und wieder zurück nach vorne. Wiederhole die Bewegung.",
      "Lege dich bäuchlings auf den Boden, strecke deine Arme nach vorne und deine Beine nach hinten aus. Erhebe deinen Oberkörper und deine Beine. Bringe deine gestreckten Arme neben deinen Körper und wieder zurück nach vorne. Senke Oberkörper und Beine zum Boden und erhebe sie erneut. Bringe die Arme erneut neben deinen Körper."
    ]
  ],
  /* record */[
    /* id */17,
    /* description : array */[
      "Lege dich auf deine rechte Seite, deine Beine sind leicht angewinkelt und das linke Bein liegt auf dem rechten. Lege nun deinen rechten Unterarm auf dem Boden ab, sodass du dich in einem Seitstütz befindest. Greife mit dem linken (oberen) Arm unter deinem Oberkörper durch, dein Körper folgt der Bewegung. Bringe nun denselben Arm zurück nach oben, dein Körper folgt der Bewegung erneut. Dein Arm befindet sich nun senkrecht zum Boden. Wiederhole die Bewegung mit demselben Arm. Im nächsten Satz wechselst du die Seite.",
      "Lege dich auf deine rechte Seite, deine Beine sind gestreckt, deine Knie berühren nicht den Boden und das linke Bein liegt auf dem rechten. Lege nun deinen rechten Unterarm auf dem Boden ab, sodass du dich in einem Seitstütz befindest. Greife mit dem linken (oberen) Arm unter deinem Oberkörper durch, dein Körper folgt der Bewegung. Bringe nun denselben Arm zurück nach oben, dein Körper folgt der Bewegung erneut. Dein Arm befindet sich nun senkrecht zum Boden. Wiederhole die Bewegung mit demselben Arm. Im nächsten Satz wechselst du die Seite.",
      "Positioniere dich in der Liegestützposition auf beiden Händen und auf den Füßen. Greife mit dem linken Arm unter deinem Oberkörper durch, dein Körper folgt der Bewegung. Bringe nun denselben Arm zurück nach oben, dein Körper folgt der Bewegung erneut. Dein Arm befindet sich nun senkrecht zum Boden. Wiederhole die Bewegung mit demselben Arm. Im nächsten Satz wechselst du die Seite."
    ]
  ],
  /* record */[
    /* id */18,
    /* description : array */[
      "Positioniere die Hände auf dem Boden. Strecke ein Bein nach hinten aus und lasse das andere Bein folgen. Die Füße stehen nun auf den Fußspitzen und du bist in der Liegestützposition. Ziehe nun ein Knie nach vorne, stelle den Fuß des angezogenen Beines auf und lasse den anderen Fuß folgen. Drücke dich aus den Armen und Beinen nach oben und strecke die Hände über dem Kopf aus.",
      "Platziere beide Hände vor dir auf dem Boden. Springe mit den Füßen nach hinten in den Liegestützstand. Springe nun mit den Füßen zwischen deine Hände und dann soweit wie möglich nach oben.",
      "Platziere beide Hände vor dir auf dem Boden. Springe mit den Füßen nach hinten in den Liegestützstand. Lass nun die Hüfte Richtung Boden sinken und von der Hüfte aufwärts, Wirbel für Wirbel den Körper den Boden berühren. Schließlich berührt die Brust den Boden und deine Hände befinden sich in etwa auf Höhe des Rippenbogens. Von hier aus drückst du nun deinen Oberkörper nach oben und lässt nach der Brust, Wirbel für Wirbel den Rest des Körpers in einer schlängelnden Bewegung folgen. Springe nun mit den Füßen zwischen deine Hände und dann soweit wie möglich nach oben."
    ]
  ],
  /* record */[
    /* id */19,
    /* description : array */[
      "Stelle dich in etwa hüftbreit hin und die Füße in einer Außenrotation ca. 30-45 Grad nach außen auf. Halte deine Arme vor oder neben deinem Körper. Schiebe deine Hüfte nach hinten. Knicke in den Knien ein. Schiebe die Knie nach außen und lasse das Gesäß nach unten und hinten wandern. Drück dich nun wieder nach oben und führe die Hüfte zurück nach vorne.",
      "Stelle dich in etwa hüftbreit hin und die Füße in einer Außenrotation ca. 30-45 Grad nach außen auf. Halte deine Arme vor oder neben deinem Körper. Schiebe deine Hüfte nach hinten. Knicke in den Knien ein. Schiebe die Knie nach außen und lasse das Gesäß nach unten und hinten wandern. Nachdem du den untersten Punkt erreicht hast, richtest du dich mit einem Sprung wieder auf.",
      "Stelle dich in etwa hüftbreit hin und die Füße in einer Außenrotation ca. 30-45 Grad nach außen auf. Halte deine Arme vor oder neben deinem Körper. Schiebe deine Hüfte nach hinten. Knicke in den Knien ein. Schiebe die Knie nach außen und lasse das Gesäß nach unten und hinten wandern. Leite am untersten Punkt die Aufwärtsbewegung ein, allerdings nicht bis zum aufrechten Stand, sondern so, dass deine Beine noch leicht gebeugt sind. Gehe dann erneut in die tiefste Position. Springe nun zurück in einen aufrechten Stand."
    ]
  ],
  /* record */[
    /* id */20,
    /* description : array */[
      "Stelle dich hüftbreit hin und halte deine Arme locker neben deinem Körper. Mache mit deinem rechten Bein einen großen Schritt nach diagonal vorne, also so, dass deine Beine nicht auf einer Linie sind, sondern das rechte Bein versetzt zum linken steht. Beuge das rechte Knie soweit, bis sich dein linkes Knie kurz vor dem Boden befindet. Drücke dich aus dem rechten Bein nach oben zurück in die Ausgangsposition und wiederhole die Bewegung mit dem anderen Bein.",
      "Stelle dich hüftbreit hin und halte deine Arme locker neben deinem Körper. Mache mit deinem rechten Bein einen großen Schritt nach diagonal vorne, also so, dass deine Beine nicht auf einer Linie sind, sondern das rechte Bein versetzt zum linken steht. Beuge das rechte Knie soweit, bis sich dein linkes Knie kurz vor dem Boden befindet. Drücke dich nun mit dem rechten Bein nach oben, allerdings so, dass das Bein noch leicht gebeugt ist und behalte die Fußposition bei. Beuge nun erneut das Knie des rechten Beines und komme so in die tiefste Position. Drücke dich erst jetzt zurück in die Ausgangsposition und wiederhole die Bewegung mit dem anderen Bein.",
      "Stelle dich hüftbreit hin und halte deine Arme locker neben deinem Körper. Mache mit deinem rechten Bein einen großen Schritt nach diagonal vorne, also so, dass deine Beine nicht auf einer Linie sind, sondern das rechte Bein versetzt zum linken steht. Beuge das rechte Knie soweit, bis sich dein linkes Knie kurz vor dem Boden befindet. Drücke dich in der tiefsten Position aus dem rechten Bein nach oben. Bevor du dein linkes Bein wieder neben dem rechten platzierst, ziehst du dein linkes Knie zur Brust. Erst dann stellst du dein Bein ab."
    ]
  ],
  /* record */[
    /* id */21,
    /* description : array */[
      "Lege dich auf den Rücken, deine Arme befinden sich neben deinem Körper, die Handflächen berühren den Boden. Hebe nun deine gestreckten Beine an, bis diese in einem 90-Grad-Winkel zu deinem Körper stehen. Hebe nun deine Hüfte vom Boden ab. Achte darauf, diese Bewegung kontrolliert und ohne Schwung durchzuführen. Lege deine Hüfte wieder ab.",
      "Lege dich auf den Rücken, deine Arme befinden sich neben deinem Körper, die Handflächen berühren den Boden. Hebe nun deine gestreckten Beine an, bis diese in einem 90-Grad-Winkel zu deinem Körper stehen. Hebe nun deine Hüfte vom Boden ab. Achte darauf, diese Bewegung kontrolliert und ohne Schwung durchzuführen. Bevor du die Hüfte ablegst, bewege sie wieder erneut nach oben und lege sie dann ab.",
      "Lege dich auf den Rücken, deine Arme befinden sich neben deinem Körper, die Handflächen berühren den Boden. Bringe dann deine Beine Richtung Boden. Hebe nun deine gestreckten Beine an, bis diese in einem 90-Grad-Winkel zu deinem Körper stehen. Hebe nun deine Hüfte vom Boden ab. Achte darauf, diese Bewegung kontrolliert und ohne Schwung durchzuführen. Lege die Beine jedoch nicht ab, sondern bringe sie kurz vor dem Boden erneut nach oben. Mache nun wieder einen Hüftstoß."
    ]
  ],
  /* record */[
    /* id */22,
    /* description : array */[
      "Du stehst hüftbreit. Mache einen großen Schritt nach vorne und beuge das vordere Bein, sodass die Wade und der Oberschenkel dieses Beines einen 90-Grad-Winkel ergeben. Halte den Oberkörper dabei aufrecht. Springe explosiv nach oben. Tausche in der Luft die Position deiner Beine und gehe nach der Landung auf dem Boden erneut in einen Ausfallschritt, nun befindet sich allerdings das andere Bein vorne. Springe erneut ab.",
      "Du stehst hüftbreit. Mache einen großen Schritt nach vorne und beuge das vordere Bein, sodass die Wade und der Oberschenkel dieses Beines einen 90-Grad-Winkel ergeben. Halte den Oberkörper dabei aufrecht. Springe explosiv nach oben. Tausche in der Luft die Position deiner Beine und gehe nach der Landung auf dem Boden erneut in einen Ausfallschritt, nun befindet sich allerdings das andere Bein vorne. Bevor du nun erneut abspringst, streckst du deine Beine aus und senkst sie daran anschließend wieder, sodass du dich nun erneut in einem Ausfallschritt befindest. Erst dann springst du ab und wiederholst die Ausführung mit dem anderen Bein vorne.",
      "Du stehst hüftbreit. Mache einen großen Schritt nach vorne und beuge das vordere Bein, sodass die Wade und der Oberschenkel dieses Beines einen 90-Grad-Winkel ergeben. Halte den Oberkörper dabei aufrecht. Du befindest dich in einem Ausfallschritt, dein rechtes Bein ist vorne. Springe nach oben und positioniere die Füße bei der Landung nebeneinander etwas breiter als hüftbreit auf dem Boden. Gehe in eine Kniebeuge. Beuge dafür deine Beine im Kniegelenk und schiebe dein Gesäß nach hinten. Gehe so weit nach unten, wie es dir möglich ist. Springe nun wieder nach oben und bringe das linke Bein nach vorne. Gehe in einen Ausfallschritt und springe erneut ab."
    ]
  ],
  /* record */[
    /* id */23,
    /* description : array */[
      "Stelle dich aufrecht hin, die Füße zeigen nach vorne. Beuge deinen Oberkörper mit geradem Rücken nach vorne. Dein Oberkörper befindet sich nun parallel zum Boden. Hebe gleichzeitig dein linkes Bein nach hinten oben an. Strecke beide Arme nach unten. Kehre zurück in die Ausgangsposition und wiederhole die Bewegung mit der anderen Seite.",
      "Stelle dich aufrecht hin, die Füße zeigen nach vorne. Beuge deinen Oberkörper mit geradem Rücken nach vorne. Dein Oberkörper befindet sich nun parallel zum Boden. Hebe gleichzeitig dein linkes Bein nach hinten oben an. Strecke beide Arme nach unten. Richte nun deinen Körper auf und ziehe das Knie des linken hinteren Beines zur Brust. Stelle es dann auf den Boden und wiederhole die Bewegung mit der anderen Seite.",
      "Stelle dich aufrecht hin, die Füße zeigen nach vorne. Beuge deinen Oberkörper mit geradem Rücken nach vorne. Dein Oberkörper befindet sich nun parallel zum Boden. Hebe gleichzeitig dein linkes Bein nach hinten oben an. Strecke beide Arme nach unten. Richte nun deinen Körper auf und mache mit dem hinteren Bein einen Schritt nach vorne. Beuge dein Knie, Ober- und Unterschenkel befindet sich in einem 90-Grad-Winkel. Deine Arme sind neben dem Körper. Drücke dich zurück in den Stand und wiederhole die Übung mit dem anderen Bein."
    ]
  ],
  /* record */[
    /* id */24,
    /* description : array */[
      "Gehe in den Vierfüßlerstand und stütze dich dabei auf deine Hände. Hebe dein rechtes Bein zur rechten Seite an, ohne es dabei auszustrecken. Dein Ober- und Unterschenkel befinden sich also immer in einem 90-Grad-Winkel zueinander. Halte das Bein kurz auf Hüfthöhe und senke es ab. Wiederhole die Bewegung mit dem linken Bein.",
      "Gehe in den Vierfüßlerstand und stütze dich dabei auf deine Hände. Dein Ober- und Unterschenkel befinden sich also immer in einem 90-Grad-Winkel zueinander. Hebe dein rechtes Bein zur rechten Seite an, ohne es dabei auszustrecken. Gleichzeitig mit deinem rechten Bein streckst du deinen linken Arm nach vorne aus, sodass er sich in einer Linie mit deinem Oberkörper befindet. Wiederhole die Ausführung mit deinem linken Bein und rechten Arm.",
      "Gehe in den Vierfüßlerstand und stütze dich dabei auf deine Hände. Dein Ober- und Unterschenkel befinden sich also immer in einem 90-Grad-Winkel zueinander. Hebe dein rechtes Bein zur rechten Seite an, ohne es dabei auszustrecken. Gleichzeitig mit deinem rechten Bein streckst du deinen rechten Arm nach vorne aus, sodass er sich in einer Linie mit deinem Oberkörper befindet. Wiederhole die Ausführung mit deinem linken Bein und linken Arm."
    ]
  ],
  /* record */[
    /* id */25,
    /* description : array */[
      "Lege dich auf den Rücken und verschränke die Arme als Nackenstütze hinter dem Kopf. Platziere die Fersen auf dem Boden und ziehe die Knie an. Rotiere jetzt in einer kreisförmigen Bewegung: erst mit dem linken Ellenbogen in die Richtung des rechten Knies, dann weiter zum linken Knie und zurück in die Ausgangsposition. Wiederhole nun die Bewegung in die andere Richtung.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */26,
    /* description : array */[
      "Lege dich auf den Rücken, deine Arme liegen neben deinem Körper. Hebe nun ein Bein an, bis es senkrecht zu deinem Körper steht. Das Bein ist dabei minimal angewinkelt, das andere Bein liegt auf der Matte. Senke das Bein bis kurz vor dem Boden und beginne dann die gleiche Bewegung mit dem anderen Bein.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */27,
    /* description : array */[
      "Lege dich auf den Rücken und führe deine Fußsohlen zusammen, deine Knie zeigen dabei nach außen. Ziehe den Bauch ein. Strecke deine Arme in die Richtung deiner Füße. Komme mit deinem Oberkörper nach oben und berühre bei jeder Bewegung mit deinen Händen die Füße. Senke den Oberkörper ab, indem du Wirbel für Wirbel abrollst und so in die Ausgangsposition zurückkehrst.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */28,
    /* description : array */[
      "Setze dich auf dein Gesäß und platziere die Fersen vor dir. Strecke die Hände vor dem Körper aus. Hebe die Beine vom Boden ab und lehne deinen Oberkörper nach hinten, halte dabei die Balance. Führe deinen Oberkörper gleichzeitig mit deinen Beinen nach oben. Lehne dich wieder zurück, bis du dich erneut in der Startposition befindest.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */29,
    /* description : array */[
      "Lege dich auf den Rücken, deine Beine befinden sich auf einer Erhöhung oder sind gegen die Wand gepresst. Deine Arme streckst du senkrecht zu deinem Körper nach oben, die Handflächen berühren sich. Löse die Schulterblätter explosiv vom Boden und wandere mit der linken Schulter in die Richtung deines rechten Knies. Senke den Oberkörper nun wieder ab und wiederhole die Bewegung auf die andere Seite.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */30,
    /* description : array */[
      "Lege dich bäuchlings auf den Boden und stütze dich auf deine Unterarme, die sich parallel zueinander unter deinen Schultern befinden. Deine Beine sind gerade in Hüftbreite nach hinten ausgestreckt. Hebe deine Hüfte, sodass sich dein Körper in einer Linie befindet, der Rücken ist gerade. Bringe die Beine nun im Sprung abwechselnd nach außen und wieder nach innen.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */31,
    /* description : array */[
      "Stelle dich an eine Wand, versetze deinen Oberkörper unter Spannung und beuge deine Beine im Kniegelenk, bis deine Waden und Oberschenkelrückseiten ungefähr einen 90-Grad-Winkel zueinander ergeben. Lehne dich mit dem Rücken vollständig gegen die Wand und halte die Position.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */32,
    /* description : array */[
      "Halte dich an der Wand oder einem stabilen Gegenstand fest. Strecke das Bein, das sich an der Seite der Wand befindet, nach vorne. Beuge nun das andere Bein und neige den Oberkörper nach vorne, der Oberschenkel befindet sich nun parallel zum Boden. Drücke dich aus dem Standbein nach oben und wiederhole die Bewegung. Wechsle im nächsten Intervall das Standbein.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */33,
    /* description : array */[
      "Stelle dich schulterbreit hin, deine Hände sind hinter deinem Kopf, die Ellenbogen gehen nach außen. Gehe leicht in die Knie. Schiebe deine Hüfte nach hinten, sodass du eine Dehnung in den hinteren Oberschenkeln spürst. Bringe deinen Oberkörper gleichzeitig nach vorne, bis deine Brust parallel zum Boden ist. Stelle dich wieder aufrecht hin und wiederhole die Bewegung.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */34,
    /* description : array */[
      "Stelle dich aufrecht hin. Mache einen Schritt nach links. Beuge dein linkes Knie, der Oberkörper kommt leicht nach vorne. Drücke dich aus dem gebeugten Bein nach oben, bis du wieder stehst. Wiederhole die Übung in die andere Richtung.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */35,
    /* description : array */[
      "Stelle dich schulterbreit hin. Hebe das rechte Bein auf 45 Grad zur rechten Seite an. Die Zehenspitzen sind angezogen. Halte die Position für wenige Sekunden und bringe das Bein zurück in die Ausgangsposition, setze es allerdings noch nicht ab. Führe nun deine rechte Ferse zum Gesäß, indem du dein Knie beugst. Halte diese Position ebenfalls für wenige Sekunden und setze das Bein dann ab. Wechsle nun das Bein.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */36,
    /* description : array */[
      "Stelle dich aufrecht hin und beuge deinen Unterschenkel nach oben, er ist nun parallel zum Boden.\n        Schließe die Augen und halte das Gleichgewicht. Du kannst die Übung erschweren, indem du deinen Kopf in den Nacken legst oder eine weiche Unterlage verwendest.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */37,
    /* description : array */[
      "Begib dich mit schulterbreitem Stand in eine Kniebeugeposition, während dein Körper aufrecht bleibt. Deine Arme befinden sich vor deinem Körper. Bewege dein rechtes Knie nach vorne zum Boden und verlagere dein Körpergewicht auf das andere Bein. Wechsle die Seite und bewege dann immer abwechselnd die Knie zum Boden und zurück. Halte dabei deinen Oberkörper so aufrecht wie möglich und bewege ausschließlich deine Beine bzw. Hüfte.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */38,
    /* description : array */[
      "Lege eine Matte vor eine freie Wand oder ein Sofa. Du befindest dich mit dem Rücken zur Wand/zum Sofa. Stelle ein Bein nach vorne auf, während das hintere Bein komplett gebeugt an der Wand bzw. dem Sofa steht und du eine Dehnung in deiner Oberschenkelvorderseite merkst. Das Kniegelenk des vorderen Beins ist ca. 90 Grad gebeugt, das hintere Bein liegt ca. 20-30 cm von der Wand entfernt auf dem Knie. Der Oberkörper ist dabei gerade, du kannst dich auf dem vorderen Bein etwas abstützen. In der Position hältst du die Spannung und solltest eine Dehnung im Oberschenkel bis hin zur Hüfte merken. Die Hüfte kannst du gelegentlich nach vorne bewegen und dein Gesäß anspannen, um eine stärkere Dehnung zu spüren.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */39,
    /* description : array */[
      "Stelle dich hüftbreit mit dem Blick zu einer Wand. Lege deine Handflächen auf Schulterhöhe an der Wand ab, die Fingerspitzen zeigen nach außen. Löse nun den rechten Arm von der Wand, strecke ihn seitlich auf Schulterhöhe neben dir aus und rotiere deinen kompletten Körper nach rechts. Dein Blick folgt dabei deinem Arm.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */40,
    /* description : array */[
      "Begib dich mit schulterbreitem Stand in eine Kniebeugeposition, während dein Körper aufrecht bleibt und sich deine Arme vor deinem Körper befinden. Greife mit deiner linken Hand deinen linken Fuß, um dich dort zu stabilisieren. Drehe nun deinen Oberkörper mit deiner gestreckten rechten Hand seitlich auf, der Oberkörper und Kopf folgen dem Arm. Atme bei der seitlichen Aufdrehung aus, bleibe dabei aufrecht mit geradem Rücken und drehe danach langsam zurück in die Ausgangsposition, um die Seite zu wechseln.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */41,
    /* description : array */[
      "Stelle dich gerade vor eine freie Wand und lege beide Hände mit den gesamten Handflächen schulterbreit an die Wand. Die Arme sind dabei parallel zum Boden und komplett gestreckt. Beuge nun deinen Körper und führe eine Kniebeuge aus. In der Bewegung bleiben beide Hände an der gleichen Position und die Arme bleiben dauerhaft gestreckt. Beuge dich so weit du kannst nach unten, bis die Hände in einer Linie mit deinem geraden Rücken sind und atme ein. Bewege deinen Körper wieder zurück in die Ausgangsposition und atme dabei aus.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */42,
    /* description : array */[
      "Lege dich seitlich auf eine Matte und winkle die Beine leicht an. Lege die Arme gestreckt vor dem Körper ab. Drehe deinen Oberkörper nun so weit es geht mit gestrecktem Arm seitlich zur anderen Seite auf. Nur der Oberkörper bewegt sich, während die Beine weiterhin leicht gebeugt auf der Matte liegen. Atme bei der Drehung aus und atme bei der Bewegung zur Ausgangsposition ein. Wechsle nach 10 Wiederholungen die Seite.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */43,
    /* description : array */[
      "Stelle dich zunächst aufrecht hin. Hebe nun ein Bein nach hinten vom Boden ab und leite so eine Abwärtsbewegung des Körpers nach vorne ein. Gleichzeitig streckst du deine Arme zur Seite aus. Körper, Bein und Arme sind nun auf einer Linie parallel zum Boden. Halte diese Position.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */44,
    /* description : array */[
      "Nimm eine Liegestützposition ein, deine Hände befinden sich unter der Brust. Der Rücken ist gerade. Dein Gewicht wird nun auf einen Arm verlagert, den anderen Arm streckst du senkrecht zum Boden nach oben. Dein Blick folgt der Hand und dein kompletter Körper routiert in die Richtung dieses Armes.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */45,
    /* description : array */[
      "Nimm eine Liegestützposition ein, deine Beine sind leicht gegrätscht, deine Hände befinden sich unter den Schultern. Entferne dein rechtes Bein wenige Zentimeter vom Boden, lass deine Zehen dabei angezogen. Führe deinen rechten Fuß in die Richtung des linken Fußes und anschließend wieder zurück. Führe dasselbe Bein nach oben und wieder zurück nach unten. Wiederhole die Bewegung.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */46,
    /* description : array */[
      "Nimm einen Seitstütz ein, deine Ellenbogen befinden sich unter den Schultern. Deine Beine sind gerade in Hüftbreite nach hinten ausgestreckt. Schiebe nun deinen Körper nach hinten. Indem du deine Zehen durchstreckst, schiebst du deinen Körper dann zurück nach vorne.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */47,
    /* description : array */[
      "Nimm einen Unterarmstütz ein. Du befindest dich hierfür auf den Unterarmen und Zehenspitzen. Deine Beine sind in Hüftbreite nach hinten ausgestreckt. Hebe deine Hüfte, sodass sich dein Körper in einer Linie befindet, der Rücken ist gerade. Halte diese Position.",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */48,
    /* description : array */[
      "Lege dich seitlich auf den Boden. Stütze dich auf deinen Unterarm, sodass deine Hand nach vorne in Blickrichtung zeigt und sich dein Ellenbogen unter deiner Schulter befindet. Die Beine liegen parallel aufeinander und deine Zehen zeigen in Blickrichtung. Atme ein und drücke deinen Körper beim Ausatmen seitlich nach oben. Halte die Position für ein paar Sekunden und lasse deinen Körper beim Einatmen wieder herabsinken, ohne ihn vollständig auf dem Boden abzulegen. Im nächsten Intervall ist die andere Seite oben.",
      "",
      ""
    ]
  ]
];

exports.workoutLevels = workoutLevels;
exports.exercises = exercises;
exports.workoutMatrix = workoutMatrix;
exports.workoutsStatus = workoutsStatus;
exports.getWorkoutTitles = getWorkoutTitles;
exports.getWorkoutIds = getWorkoutIds;
exports.workoutReps = workoutReps;
exports.completedArray = completedArray;
exports.bonusDone = bonusDone;
exports.knowledgeRead = knowledgeRead;
exports.knowledgeEntries = knowledgeEntries;
exports.exerciseImagesCount = exerciseImagesCount;
exports.exerciseDescriptions = exerciseDescriptions;
/* No side effect */



//////////////////
// WEBPACK FOOTER
// ./src/seed.re
// module id = 17
// module chunks = 0